import React, { type JSX } from 'react';
import { Button, Divider, Dialog, DialogActions, DialogContent, Typography } from '@mui/material';
import type { RampShedAction } from './types';
import { CustomTransComponent } from 'components';
import { useTranslation } from 'react-i18next';
import { useNewCustomTranslations } from 'hooks';

interface BeginRampShedModalProps {
    open: boolean;
    action: RampShedAction;
    selectedCount: number;
    onConfirm: () => void;
    onCancel: () => void;
}

export const BeginRampShedModal = ({ open, action, onConfirm, onCancel }: BeginRampShedModalProps): JSX.Element => {
    const { t } = useTranslation();
    useNewCustomTranslations('RAMP_SHED');
    const isRamp = action === 'ramp';
    const actionLabel = isRamp ? t('RAMP_SHED:LABELS.RAMP') : t('RAMP_SHED:LABELS.SHED');
    const actionVerb = isRamp ? t('RAMP_SHED:LABELS.RAMPING') : t('RAMP_SHED:LABELS.SHEDDING');

    return (
        <Dialog
            open={open}
            onClose={onCancel}
            PaperProps={{
                sx: {
                    width: { xs: 'calc(100vw - 32px)', sm: 450 },
                    maxWidth: { xs: 'calc(100vw - 32px)', sm: 450 },
                    height: { xs: 'auto', sm: 191 },
                    minHeight: { sm: 191 },
                    m: { xs: 2, sm: 0 },
                },
            }}
        >
            <DialogContent sx={{ pt: 4, pb: 3 }}>
                <Typography variant="h6" color="text.primary" sx={{ fontWeight: 600 }}>
                    {t('RAMP_SHED:LABELS.BEGIN_ACTION_TITLE', { actionVerb })}
                </Typography>
            </DialogContent>
            <Divider />
            <DialogActions
                sx={{
                    px: 3,
                    pb: 2,
                    gap: 4,
                    '& > :not(style) ~ :not(style)': {
                        ml: 0,
                    },
                }}
            >
                <Button variant="outlined" onClick={onCancel}>
                    <CustomTransComponent translationKey={'RAMP_SHED:BUTTONS.CANCEL'} />
                </Button>
                <Button
                    variant="contained"
                    color="primary"
                    onClick={onConfirm}
                    sx={{ '&:hover': { backgroundColor: 'primary.main' } }}
                >
                    {t('RAMP_SHED:BUTTONS.BEGIN_ACTION', { actionLabel })}
                </Button>
            </DialogActions>
        </Dialog>
    );
};
